export const GET_OFFER_INSIGHTSTATS_API_REQUEST = "GET_OFFER_INSIGHTSTATS_API_REQUEST";
export const GET_OFFER_INSIGHTSTATS_API_SUCCESS = "GET_OFFER_INSIGHTSTATS_API_SUCCESS";
export const GET_OFFER_INSIGHTSTATS_API_ERROR = "GET_OFFER_INSIGHTSTATS_API_ERROR";

export const GET_OFFER_INSIGHTS_API_REQUEST = "GET_OFFER_INSIGHTS_API_REQUEST";
export const GET_OFFER_INSIGHTS_API_SUCCESS = "GET_OFFER_INSIGHTS_API_SUCCESS";
export const GET_OFFER_INSIGHTS_API_ERROR = "GET_OFFER_INSIGHTS_API_ERROR";
export const OFFER_INSIGHTS_NEXT_PAGE = "OFFER_INSIGHTS_NEXT_PAGE"
export const OFFER_INSIGHTS_PREV_PAGE = "OFFER_INSIGHTS_PREV_PAGE"
export const OFFER_INSIGHTS_FILTER_CHANGE = "OFFER_INSIGHTS_FILTER_CHANGE"
export const OFFER_INSIGHTS_SEARCH_CHANGE = "OFFER_INSIGHTS_SEARCH_CHANGE"

export const GET_PROFILE_PERFORMANCE_INSIGHTS_API_REQUEST = "GET_PROFILE_PERFORMANCE_INSIGHTS_API_REQUEST";
export const GET_PROFILE_PERFORMANCE_INSIGHTS_API_SUCCESS = "GET_PROFILE_PERFORMANCE_INSIGHTS_API_SUCCESS";
export const GET_PROFILE_PERFORMANCE_INSIGHTS_API_ERROR = "GET_PROFILE_PERFORMANCE_INSIGHTS_API_ERROR";


export const GET_USER_SETTING_API_REQUEST = "GET_USER_SETTING_API_REQUEST";
export const GET_USER_SETTING_API_SUCCESS = "GET_USER_SETTING_API_SUCCESS";
export const GET_USER_SETTING_API_ERROR = "GET_USER_SETTING_API_ERROR";
export const SAVE_USER_SETTING_API_REQUEST = "SAVE_USER_SETTING_API_REQUEST";
export const UPDATE_USER_SETTING_API_REQUEST = "UPDATE_USER_SETTING_API_REQUEST";

export const SET_RANGE_DATES = "SET_RANGE_DATES";